import { progressConstants } from '../constants';
import { saveParams, deleteParams, createParams } from './base.reducers';

const name = 'progresses';

const initialState = {
	saveLoading: 0,
	saveSuccess: false,
	deleteLoading: 0,
	allLoading: 0,

	progresses: [],
	progressesById: {},
	allProgressesByRecipientId: {}
};

export default (state = initialState, payload) => {
	const { type, data } = payload;
	switch (type) {
		// Save and edit progresses
		case progressConstants.SAVING_PROGRESS_REQUEST:
			return {
				...state,
				saveSuccess: false,
				saveLoading: state.saveLoading + 1,
			};
		case progressConstants.SAVING_PROGRESS_SUCCESS:
			const { form } = data;
			return {
				...saveParams({ name, state, form }),
				saveLoading: state.saveLoading - 1,
				saveSuccess: true
			};
		case progressConstants.SAVING_PROGRESS_FAILURE:	
			return {
				...state,
				saveLoading: state.saveLoading - 1,
			};
		// Delete progress
		case progressConstants.DELETE_PROGRESS_REQUEST:
			return {
				...state,
				deleteLoading: state.deleteLoading + 1,
			};
		case progressConstants.DELETE_PROGRESS_SUCCESS:
			const id = data;
			return {
				...deleteParams({ name, state, id }),
				deleteLoading: state.deleteLoading - 1
			};
		case progressConstants.DELETE_PROGRESS_FAILURE:	
			return {
				...state,
				deleteLoading: state.deleteLoading + 1,
			};
		// Load progresses
		case progressConstants.LOAD_PROGRESS_REQUEST:
			return {
				...state,
				allLoading: state.allLoading + 1,
			};
		case progressConstants.LOAD_PROGRESS_SUCCESS:
			const params = createParams({ name, state, data: data.data });
			const recipientId = data.data[0] ? data.data[0].recipient_id : null;
			const allProgressesByRecipientId = recipientId ? {...state.allProgressesByRecipientId, [recipientId]: params.progresses} : state.allProgressesByRecipientId;
			return {
				...params,
				allProgressesByRecipientId,
				allLoading: state.allLoading - 1
			};
		case progressConstants.LOAD_PROGRESS_FAILURE:	
			return {
				...state,
				allLoading: state.allLoading - 1,
			};
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/redux/reducers/progress.reducers.js